import {
  mdiAccount,
  mdiAccountBoxOutline,
  mdiBriefcaseOutline,
  mdiEmailOutline,
  mdiFormatColumns,
  mdiFormatListBulletedType,
  mdiHandshakeOutline,
  mdiHelpCircleOutline,
  mdiMapLegend,
  mdiNoteTextOutline,
  mdiPost,
  mdiPoundBoxOutline,
  mdiTextBoxOutline,
  mdiTimelineOutline,
  mdiViewDashboard,
} from '@mdi/js';
import { EUserRoles } from '../models/user.model';

export interface NavigationItemOption {
  icon: string;
  path: string;
  title: string;
  roles?: EUserRoles[];
  color?: string;
}

export const navItems: NavigationItemOption[] = [
  {
    path: '/dashboard',
    icon: mdiViewDashboard,
    title: 'Dashboard',
  },
  {
    path: '/blog',
    icon: mdiNoteTextOutline,
    title: 'Blog',
    roles: [EUserRoles.Admin, EUserRoles.Editor],
    color: '#3a7cbd',
  },
  {
    path: '/green-hub',
    icon: mdiPost,
    title: 'Green Hub',
    roles: [EUserRoles.Admin, EUserRoles.Editor],
    color: '#15c572',
  },
  {
    path: '/newsletter',
    icon: mdiEmailOutline,
    title: 'Newsletter',
    roles: [EUserRoles.Admin, EUserRoles.Editor],
    color: '#ff9800',
  },
  {
    path: '/start-up',
    icon: mdiFormatListBulletedType,
    title: 'Start-up',
    roles: [EUserRoles.Admin, EUserRoles.Editor],
    color: '#e91e63',
  },
  {
    path: '/investor',
    icon: mdiPoundBoxOutline,
    title: 'Investor',
    roles: [EUserRoles.Admin, EUserRoles.Editor],
    color: '#e91e63',
  },

  {
    path: '/faq',
    icon: mdiHelpCircleOutline,
    title: 'FAQ',
    roles: [EUserRoles.Admin, EUserRoles.Editor],
    color: '#2bc1c7',
  },
  {
    path: '/training-document',
    icon: mdiTextBoxOutline,
    title: 'Training document',
    roles: [EUserRoles.Admin, EUserRoles.Editor],
    color: '#007c81',
  },
  {
    path: '/contact-submission',
    icon: mdiFormatColumns,
    title: 'Contact Form Submission',
    roles: [EUserRoles.Admin],
    color: '#72c303',
  },
  {
    path: '/partner',
    icon: mdiHandshakeOutline,
    title: 'Partner',
    roles: [EUserRoles.Admin, EUserRoles.Editor],
    color: '#3a7cbd',
  },
  {
    path: '/mentor',
    icon: mdiAccountBoxOutline,
    title: 'Mentor',
    roles: [EUserRoles.Admin, EUserRoles.Editor],
    color: '#15c572',
  },
  {
    path: '/portfolio',
    icon: mdiBriefcaseOutline,
    title: 'Portfolio',
    roles: [EUserRoles.Admin, EUserRoles.Editor],
    color: '#187202',
  },
  {
    path: '/region',
    icon: mdiMapLegend,
    title: 'Region',
    roles: [EUserRoles.Admin, EUserRoles.Editor],
    color: '#c3ac41',
  },
  // {
  //   path: '/phase',
  //   icon: mdiTimelineOutline,
  //   title: 'Phase',
  //   roles: [EUserRoles.Admin, EUserRoles.Editor],
  //   color: '#c341b4',
  // },
  {
    path: '/user',
    icon: mdiAccount,
    title: 'User',
    roles: [EUserRoles.Admin],
    color: '#2bc1c7',
  },
];
